import {
    ctdUserInteractionDefinition,
    OpenInteractionLayerWithFeatureApp
} from '@volkswagen-onehub/ctd-user-interaction';
import {ServiceRegistration} from './ServiceRegistration';

export function createCtdUserInteraction(): ServiceRegistration<OpenInteractionLayerWithFeatureApp> {
    const definition = ctdUserInteractionDefinition;
    return {
        definition
    };
}
